import React from 'react';
import { ConfirmationModal, Typography } from 'seagull';
import { CopyLinkForProposalModal } from "../../../hooks/useOpenCopyLinkModal/CopyLinkForProposalModal";
export const CopyLinksModal = _ref => {
  let {
    recipients,
    dismissModal
  } = _ref;
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    "data-testId": "links-modal",
    title: "Share by link",
    width: "900px",
    content: /*#__PURE__*/React.createElement(CopyLinkForProposalModal, {
      info: /*#__PURE__*/React.createElement(Typography, {
        align: "left"
      }, "Please note, while the proposal won\u2019t be sent via email, your client will still receive reminders based on your notification settings"),
      recipients: recipients
    }),
    primaryButtonLabel: "Close",
    primaryButtonTestid: "links-modal-close",
    onPrimaryButtonClick: dismissModal,
    onCloseButtonClick: dismissModal
  });
};